import React from 'react';
import Helmet from 'react-helmet';

const Title = ({ title }: { title: string }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default Title;
